import request from '@/utils/request'

// 查询栏目管理列表
export function listStorage(url,query) {
  return request({
    url: url+'/storage/list',
    method: 'get',
    params: query
  })
}

// 查询栏目管理详细
export function getStorage(url,id) {
  return request({
    url: url+'/storage/' + id,
    method: 'get'
  })
}

// 新增栏目管理
export function addStorage(url,data) {
  return request({
    url: url+'/storage',
    method: 'post',
    data: data
  })
}

// 修改栏目管理
export function updateStorage(url,data) {
  return request({
    url: url+'/storage',
    method: 'put',
    data: data
  })
}

export function delStorageByRemark(url,remark) {
  return request({
    url: url+'/storage/delApi/'+remark,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/system/objectStorage.js